import { formatValue } from 'react-currency-input-field';
import axios from 'axios';
import imageCompression from 'browser-image-compression';
import dayjs from 'dayjs';
import { compress, decompress } from 'shrink-string';
import Tippy from '@tippyjs/react';
import Swal from 'sweetalert2'
import Big from 'big.js';
import { saveAs } from 'file-saver';

const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

const { crypter_s, crypter_c } = require("../encrypt/encrypt");
const authControl = require("../auth/auth");
const jwt = require("jsonwebtoken");
// const authControl = require("../auth/auth");
dayjs.extend(utc);
dayjs.extend(timezone);

let decrypt_rs, encrypt_jwt_token, user
const checkAuth = async () => {
  let [p1, p2, p3] = await authControl.loadAuth()
  decrypt_rs = p1
  encrypt_jwt_token = p2
  user = p3
}

/**
 * Check is value is null, undefined or empty string
  @param {String} s Tester value.
  @returns {boolean} true/false
*/
const IsNotNull = (s) => {
  return s ? true : false
}

/**
 * Check is value is null, undefined or empty string
  @param {Array} s Tester value.
  @returns {boolean} true/false
*/
const IsEmptyArray = (arr) => {
  let rs = true
  if (IsNotNull(arr) && Array.isArray(arr)) {
    rs = arr.length <= 0 ? true : false
  }
  return rs
}

/**
 * Check is pattern is matching
  @param {String} v Tester value.
  @param {String} regexp Tester value.
  @returns {boolean} true/false
*/
const patternCheck = (v, regexp) => {
  return regexp.test(v);
}

const str2ab = (str) => {
  let buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  let bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

/**
 * Get Formatted Price
  @param {String} price value.
  @param {String} symbol symbol.
  @param {String} group grouping symbol.
  @param {String} decimal decimal symbol.
  @returns {String} Formatted String Price
*/
const getFormattedPrice = (price, symbol, group, decimal) => {
  let rs = formatValue({
    value: IsNotNull(price) ? price.toString() : '0',
    groupSeparator: group,
    decimalSeparator: decimal,
    prefix: symbol,
  });
  return rs;
}

/**
 * Get Formatted Number
  @param {String} num value.
  @param {String} group grouping symbol.
  @param {String} decimal decimal symbol.
  @returns {String} Formatted String Number
*/
const getFormattedNumber = (num, group, decimal, prefix, suffix) => {
  let rs = formatValue({
    value: IsNotNull(num) ? num.toString() : '0',
    groupSeparator: IsNotNull(group) ? group : '',
    decimalSeparator: IsNotNull(decimal) ? decimal : '',
    prefix: IsNotNull(prefix) ? prefix : '',
    suffix: IsNotNull(suffix) ? suffix : ''
  })
  return rs;
}

/**
 * Mapping options 
  @param {root} troot this.
  @param {Array} data options array from db.
  @param {String} data placeholder.

  @param {State} st_opt state options.
  @param {String} f1 db col id.
  @param {String} f2 db col name.
  @param {boolean} cmb combine t/f.
  @param {String} c1 db col.
  @param {String} c2 db col.
  @param {String} dlm delimeter.

  @returns {String} Formatted String Number
*/
const MappingOptions = async (troot, data, ph, st_opt, f1, f2, cmb, c1, c2, dlm) => {
  if (IsNotNull(data)) {
    let g = [];
    let delimeter = IsNotNull(dlm) ? dlm : '-'
    data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} ${delimeter} ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    await troot.setState({ [st_opt]: options })
  }
}

const MappingWNullOptions = async (troot, data, ph, st_opt, f1, f2, cmb, c1, c2) => {
  if (IsNotNull(data)) {
    let g = [{ label: 'None', value: null, o: null }];
    await data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} - ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    await troot.setState({ [st_opt]: options })
  }
}

const MappingWNullOptionsFComp = async (setFunc, data, ph, f1, f2, cmb, c1, c2) => {
  if (IsNotNull(data)) {
    let g = [{ label: 'None', value: null, o: null }];
    await data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} - ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    setFunc(options)
    // await troot.setState({ [st_opt]: options })
  }
}

/*
    Untuk cek sebelum submit
    troot: this
    rs: result var
    st1: state
    ss: state style
    erm: error message
    type: tipe input text or select or date (v/s/d)
  */
const checkValue = async (troot, rs, st1, ss, erm, type, tnotif) => {
  if (!IsNotNull(st1)) {
    rs = false;
    if (type === "v") {
      await troot.setState({ [ss]: "form-control-err" })
    } else if (type === "s") {
      await troot.setState({ [ss]: "form-select-err" })
    } else if (type === "d") {
      await troot.setState({ [ss]: "form-control-dd-err" })
    }
    IsNotNull(tnotif) ? tnotif(IsNotNull(erm) ? erm : 'Error', { variant: "error", autoHideDuration: 1200 }) : null
  }
  if (troot.state[ss].includes("err")) {
    rs = false;
  }
  return rs
}

const changeID = (arr) => {
  arr.map((x, i) => {
    x.id = i + 1
  })
}

function checkArraySimilarity(arr1, arr2) {
  let rs = false
  if ((IsNotNull(arr1) && IsNotNull(arr2)) && (!IsEmptyArray(arr1) && !IsEmptyArray(arr2))) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    rs = arr1.every((element, index) => element === arr2[index]);
  }

  return rs
}

/*
  troot: this
  find_value: find value
  st_opt: state options
  st: state name to set
*/
const FindSetOption = async (troot, find_value, st_opt, st) => {
  let s = troot.state[st];
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option.value === find_value) : null
  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  await troot.setState({ [st]: s })
}

const FindSetOption2 = async (find_value, st_opt, st) => {
  let s = { label: "", value: null, o: null };
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option.value === find_value) : null

  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  st = s
}

const FindSetOptionWKey = async (troot, find_value, st_opt, st, key) => {
  let s = troot.state[st];
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option[key] === find_value) : null
  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  await troot.setState({ [st]: s })
}

const FindOption = (find_value, st_opt) => {
  return IsNotNull(find_value) && IsNotNull(st_opt) ? st_opt.options.find(option => option.value === find_value) : ''
}

/*
  value: this
  has_dec: has decimal
  dec: max decimal
*/
const toFloat = (value, has_dec, dec) => {
  let tmp_val = IsNotNull(value) ? value : 0
  let rs = 0
  rs = parseFloat(has_dec ? parseFloat(tmp_val.toString().replace(/,/g, '.')).toFixed(dec) : tmp_val.toString().replace(/,/g, '.'))
  return rs
}

const toNonFloat = (value, dec) => {
  dec = INNRD(dec, 0);
  let tmp_val = INNRD(value, 0).toString().replace(/,/g, '.')
  let rs = Big(tmp_val)
  rs = dec > 0 ? Big(Big(tmp_val).toFixed(dec, 0)) : rs
  return rs
}
/* 
  to add suffix to time format. ex: 2 Days
*/
const FormatTime = (value, type) => {
  let suffix = ''
  if (typeof value === 'number' && value > 0) {
    switch (type) {
      case 'ss':
        suffix = value > 1 ? 'Milliseconds' : 'Millisecond'
        break;
      case 's':
        suffix = value > 1 ? 'Seconds' : 'Second'
        break;
      case 'm':
        suffix = value > 1 ? 'Minutes' : 'Minute'
        break;
      case 'h':
        suffix = value > 1 ? 'Hours' : 'Hour'
        break;
      case 'd':
        suffix = value > 1 ? 'Days' : 'Day'
        break;
      case 'M':
        suffix = value > 1 ? 'Months' : 'Month'
        break;
      case 'y':
        suffix = value > 1 ? 'Years' : 'Year'
        break;
      default:
        break;
    }
  }
  return `${value} ${suffix}`
  // dec = INNRD(dec, 0);
  // let tmp_val = INNRD(value, 0).toString().replace(/,/g, '.')
  // let rs = Big(tmp_val)
  // rs = dec > 0 ? Big(Big(tmp_val).toFixed(dec, 0)) : rs
  // return rs
}

/*
for check isnotnull or return default
  value: check value
  def: default value
*/
const INNRD = (value, def) => {
  return IsNotNull(value) ? value : def
}

/**
 * Mapping options 
  @param {any} value value to check .
  @param {any} def default return.
  @param {String} format format pattern for dayjs.
  @param {String} timezone timezone for dayjs.
  return string date
*/
const INNDRD = (value, def = '-', format = 'DD-MMMM-YYYY HH:mm:ss', timezone = null) => {
  if (!IsNotNull(value)) return def;

  let date = dayjs(value);
  
  if (!date.isValid()) return def;

  // Apply timezone if provided, otherwise just format
  return timezone 
    ? date.tz(timezone,true).format(format) 
    : date.format(format);
};

// const INNDRD = (value, def, format, timezone) => {
//   let rs = '';
//   let dformat = IsNotNull(format) ? format : 'DD-MMMM-YYYY HH:mm:ss'
//   return IsNotNull(value) ? dayjs(value).format(dformat) : def
// }


/*
for check isnotnull for select option value return default
  opt: check option
  def: default value
*/
const INNSD = (opt, def) => {
  return IsNotNull(opt.value) ? opt : def
}

const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


/**
  @param {any} value value to check.
  @param {any} v1 return this value.
  @param {any} v2 return this value.
  @param {any} c1 value 1 for compare v1.
  @param {any} c2 value 2 for compare v2.
  @param {any} def return default value.
*/
const condCheckRD = (value, def, c, v) => {
  let rs = def
  IsNotNull(value) ? IsNotNull(c) ? c.map((x, i) => { rs = x === value ? v[i] : rs }) : null : null
  return rs
}
// const condCheckRD = (value, def, c1, c2, v1, v2) => {
//   let rs = null
//   if (IsNotNull(value)) {
//     rs = value === c1 ? v1 : value === c2 ? v2 : def
//   }
//   return rs
// }

const checkTotalQty = (troot, value, rate, id) => {
  let rs = toFloat(value) * rate
  let qty_c = 0
  let total = 0, result = { status: true, exceed: 0 }
  let reqStockConv = toFloat(troot.state.obj_select.qty_conversion)
  let tmpAvQty = toFloat(troot.state[`v_available_qty${id}`])
  let rs_qty_conv = 0, rs_qty = 0
  if (patternCheck(value, /^[0-9.]*$/)) {
    troot.state.data_table.map(x => {
      let rate_x = toFloat(troot.state[`v_qty_unit${x.id}`].rate)
      let sum = toFloat(troot.state[`v_qty${x.id}`]) * rate_x
      total = total + sum
    })
    if (total > reqStockConv) {
      let exceed = total - reqStockConv
      let rs_used = rs - exceed
      if (rs_used >= tmpAvQty) {
        rs_qty = Math.floor(tmpAvQty / rate)
        rs_qty_conv = rs_qty * rate
      } else {
        rs_qty = Math.floor(rs_used / rate)
        rs_qty_conv = rs_qty * rate
      }
      troot.setState({ [`s_i_qty${id}`]: "form-control-err" })
    } else {
      if (rs > tmpAvQty) {
        rs_qty = Math.floor(tmpAvQty / rate)
        rs_qty_conv = rs_qty * rate
      } else {
        rs_qty = Math.floor(rs / rate)
        rs_qty_conv = rs_qty * rate
      }
    }
    troot.setState({
      [`v_qty_conversion${id}`]: rs_qty_conv,
      [`v_qty${id}`]: rs_qty
    })
  }
}

/**
  @param {any} x file.
  @param {any} tnotif notif component/enqueueSnackbar.
*/
const ImageCompress = async (x, tnotif) => {
  try {
    let file = x.file
    let options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    if (file.type.match('image.*')) {
      file = await imageCompression(file, options);
    }

    return new Blob([file], {
      type: file.type,
    })
  } catch (err) {
    IsNotNull(tnotif) ? tnotif(IsNotNull(erm) ? erm : 'Compress Image Failed!!', { variant: "error", autoHideDuration: 1200 }) : null
  }
}

const BlobsEqualCheck = async (blob1, blob2) => {
  if (IsNotNull(blob1) && IsNotNull(blob2)) {
    return !Buffer.from(await blob1.arrayBuffer()).compare(
      Buffer.from(await blob2.arrayBuffer())
    );
  } else {
    throw new Error('blob1 or blob2 is null!!')
  }
};

/**
  @param {any} troot this.
  @param {JSON} b parameters to get data.
  @param {any} func function from controller.
  @param {String} st_data state name for data tables.
  @param {String} st_tp state name total pages.
*/
const getAllData = async (troot, b, func, st_data, st_tp) => {
  await func(b).then(rs => {
    if (IsNotNull(rs)) {
      troot.setState({
        [`${st_data}`]: rs.data,
        [`${st_tp}`]: rs.tp
      })
    }
  })
}

/**
  @param {any} troot this.
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} st_title state name title.
  @param {String} st_desc state name description.
*/
const checkCreateResult = async (troot, x, st_title, st_desc, funcSuccess, funcError) => {

  switch (x.code) {
    case "C-01":
      troot.setState({ [`${st_title}`]: "Add Success", [`${st_desc}`]: '' });
      funcSuccess();
      break;
    case "CE-01":
      troot.setState({ [`${st_title}`]: "Already Exists", [`${st_desc}`]: '' });
      funcError()
      break;
    default:
      troot.setState({ [`${st_title}`]: "Add Failed", [`${st_desc}`]: x.message });
      funcError()
      break;
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkCreateResult2 = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {

  switch (x.code) {
    case "C-01":
      Swal.fire({
        title: IsNotNull(title) ? title : 'Create Success',
        text: IsNotNull(desc) ? desc : '',
        icon: "success",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          IsNotNull(funcSuccess) ? funcSuccess() : null
        }
      });
      break;
    case "CE-01":
      Swal.fire({
        title: IsNotNull(titleErr) ? titleErr : 'Already Exists',
        text: IsNotNull(descErr) ? descErr : IsNotNull(x.message) ? x.message : '',
        icon: "error",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          IsNotNull(funcError) ? funcError() : null
        }
      });
      // troot.setState({ [`${st_title}`]: "Already Exists", [`${st_desc}`]: '' });

      break;
    default:
      Swal.fire({
        title: IsNotNull(titleErr) ? titleErr : 'Create Failed',
        text: IsNotNull(descErr) ? descErr : IsNotNull(x.message) ? x.message : '',
        icon: "error",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          IsNotNull(funcError) ? funcError() : null
        }
      });
      // troot.setState({ [`${st_title}`]: "Add Failed", [`${st_desc}`]: x.message });
      // funcError()
      break;
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkDeleteResult = async (x, title, desc, funcSuccess, funcError) => {

  switch (x.code) {
    case "D-01":
      Swal.fire({
        title: IsNotNull(title) ? title : 'Delete Success',
        text: IsNotNull(desc) ? desc : '',
        icon: "success",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          IsNotNull(funcSuccess) ? funcSuccess() : null
        }
      });
      break;
    default:
      Swal.fire({
        title: IsNotNull(title) ? title : 'Delete Failed',
        text: IsNotNull(desc) ? desc : IsNotNull(x.message) ? x.message : '',
        icon: "error",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          IsNotNull(funcError) ? funcError() : null
        }
      });
      // troot.setState({ [`${st_title}`]: "Add Failed", [`${st_desc}`]: x.message });
      // funcError()
      break;
  }
}

/**
  @param {any} troot this.
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} st_title state name title.
  @param {String} st_desc state name description.
*/
const checkUpdateResult = async (troot, x, st_title, st_desc, funcSuccess, funcError) => {
  switch (x.code) {
    case "U-01":
      troot.setState({ [`${st_title}`]: "Update Success", [`${st_desc}`]: '' });
      funcSuccess();
      break;
    case "UE-01":
      troot.setState({ [`${st_title}`]: "Already Exists", [`${st_desc}`]: '' });
      funcError()
      break;
    default:
      troot.setState({ [`${st_title}`]: "Update Failed", [`${st_desc}`]: x.message });
      funcError()
      break;
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkApproveResult = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  if (IsNotNull(x)) {
    switch (x.code) {
      case "U-01":
        Swal.fire({
          title: IsNotNull(title) ? title : 'Approve Success',
          text: IsNotNull(desc) ? desc : '',
          icon: "success",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcSuccess) ? funcSuccess() : null
          }
        });
        break;
      default:
        Swal.fire({
          title: IsNotNull(titleErr) ? titleErr : 'Approve Failed',
          text: IsNotNull(descErr) ? descErr : x.message,
          icon: "error",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcError) ? funcError() : null
          }
        });
        break;
    }
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkFingerspotCommand = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  if (IsNotNull(x)) {
    switch (x.code) {
      case "U-01":
        Swal.fire({
          title: IsNotNull(title) ? title : 'Fingerspot Command Success',
          text: IsNotNull(desc) ? desc : '',
          icon: "success",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcSuccess) ? funcSuccess() : null
          }
        });
        break;
      default:
        Swal.fire({
          title: IsNotNull(titleErr) ? titleErr : 'Fingerspot Command Failed',
          text: IsNotNull(descErr) ? descErr : x.message,
          icon: "error",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcError) ? funcError() : null
          }
        });
        break;
    }
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkUpdateResult2 = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  if (IsNotNull(x)) {
    switch (x.code) {
      case "U-01":
        Swal.fire({
          title: IsNotNull(title) ? title : 'Update Success',
          text: IsNotNull(desc) ? desc : '',
          icon: "success",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcSuccess) ? funcSuccess() : null
          }
        });
        break;
      case "UE-01":
        Swal.fire({
          title: IsNotNull(titleErr) ? titleErr : 'Already Exists',
          text: IsNotNull(descErr) ? descErr : x.message,
          icon: "error",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcError) ? funcError() : null
          }
        });
        break;
      default:
        Swal.fire({
          title: IsNotNull(titleErr) ? titleErr : 'Update Failed',
          text: IsNotNull(descErr) ? descErr : x.message,
          icon: "error",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcError) ? funcError() : null
          }
        });
        break;
    }
  }
}


const checkDeleteResult2 = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  if (IsNotNull(x)) {
    switch (x.code) {
      case "D-01":
        Swal.fire({
          title: IsNotNull(title) ? title : 'Delete Success',
          text: IsNotNull(desc) ? desc : '',
          icon: "success",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcSuccess) ? funcSuccess() : null
          }
        });
        break;
      default:
        Swal.fire({
          title: IsNotNull(title) ? title : 'Delete Failed',
          text: IsNotNull(desc) ? desc : IsNotNull(x.message) ? x.message : '',
          icon: "error",
          draggable: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            IsNotNull(funcError) ? funcError() : null
          }
        });
        // troot.setState({ [`${st_title}`]: "Add Failed", [`${st_desc}`]: x.message });
        // funcError()
        break;
    }
  }
}

/**
  @property {props} props JSON = {title,subTitle}
  @param {String} file_name file name to save.
  @param {String} file_type file type.
*/
const notifBeforeAct = async (props) => {
  let rs = false
  await Swal.fire({
    title: IsNotNull(props.title) ? props.title : 'Are you sure?',
    text: IsNotNull(props.subTitle) ? props.subTitle : "You won't be able to revert this!",
    icon: "warning",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    showCancelButton: true,
    confirmButtonText: IsNotNull(props.confirmButtonText) ? props.confirmButtonText : 'Yes',
    denyButtonText: `Cancel`,
    animation: true
  }).then(async (result) => {
    if (result.isConfirmed) {
      rs = true
    }
  });
  return rs
}

const dynamicSort = (property) => {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

/**
  @param {blob} blob A blob data save to a file.
  @param {String} file_name file name to save.
  @param {String} file_type file type.
*/
const saveFile = (blob, file_name, file_type) => {
  try {
    if (IsNotNull(blob)) {
      file_name = IsNotNull(file_name) ? file_name : 'file'
      file_type = IsNotNull(file_type) ? file_type : 'application/pdf'
      const file = new File([blob], file_name, { type: file_type });
      let blobURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = blobURL;
      link.setAttribute("download", file_name); // Set the desired filename for the downloaded file

      // Append the <a> element to the body and click it to trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the temporary elements and URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    }
  } catch (error) {
    console.log('Download File Failed');
  }

}

const saveFileFromURL = async (url, filename) => {
  // await fetch(url).then(response => response.blob).then(blob => {
  //   console.log(blob)
  //   let objectURL = URL.createObjectURL(blob);
  //   console.log(objectURL)
  // })

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();
  saveAs(blob, filename)

}

/**
  @param {blob} blob A blob data.
  @param {String} file_name file name.
  @param {String} file_type file type.
*/
const openFileNewTab = (blob, file_name, file_type) => {
  try {
    if (IsNotNull(blob)) {
      file_name = IsNotNull(file_name) ? file_name : 'file'
      file_type = IsNotNull(file_type) ? file_type : 'application/pdf'
      const file = new File([blob], file_name, { type: file_type });
      window.open(URL.createObjectURL(file), '_blank');
    }
  } catch (error) {
    console.log('Open File Failed');
  }
}

const openURLNewTab = async (url) => {
  try {
    if (IsNotNull(url)) {
      window.open(url, '_blank', 'noopener, noreferrer');
    }
  } catch (error) {
    console.log('Open URL Failed');
  }
}

/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const DeleteData = async (b, url) => {
  let result = { code: 'D-00', status: false, message: '' }
  try {
    await checkAuth()

    await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: b.p1
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result
  }
}

/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const DeleteDataWBody = async (b, url) => {
  let result = { code: 'D-00', status: false, message: '' }
  try {
    b.update_by = await getCurrentUser()
    await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        data: await crypter_c().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result
  }
}

/**
  @param {String} url url.
*/
const GetOptData = async (url) => {
  let result = null
  try {
    await checkAuth()
    await fetch(url, {
      method: "GET",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

/**
 * get options with body
  @param {String} url url.
  @param {JSON} b json.
*/
const GetOptWBody = async (b, url) => {
  let result = null
  try {
    await checkAuth()
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: await crypter_c().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

/**
  @param {String} url url.
  @param {JSON} b JSON parameter .
*/
const GetOptData1P = async (b, url) => {
  let result = null
  try {
    await checkAuth()
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify(b),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}


/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const UpdateData = async (b, url) => {
  let result = { code: 'U-00', status: false, message: '' };
  try {
    await checkAuth()
    b.update_by = await getCurrentUser()
    await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        data: await crypter_c().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      })

  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const GetAllData = async (b, url) => {
  let result = { data: [], tp: 1 };
  try {
    await checkAuth()
    let enc = await crypter_c().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result.data = rs_d.data;
          result.tp = rs_d.total_pages;
        }
      });
  } catch (e) {
    result = { data: [], tp: 1 };
  } finally {
    return result;
  }
}

const GetData = async (b, url) => {
  let result = null;
  try {
    await checkAuth()
    let enc = await crypter_c().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null;
  } finally {
    return result;
  }
}

const GetDataWOBody = async (url) => {
  let result = null;
  try {
    await checkAuth()
    await fetch(url, {
      method: "GET",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null;
  } finally {
    return result;
  }
}

const CreateData = async (b, url) => {
  let result = { code: 'C-00', status: false, message: '' };
  try {
    b.created_by = await getCurrentUser()
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        data: await crypter_c().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => { result = x });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const CreateDataSingleFile = async (b, files, url, setPercentage) => {
  let result = null
  try {
    b.created_by = await getCurrentUser()
    const data = new FormData();
    files.map(x => {
      data.append("files", x)
    })
    data.append("data", await crypter_c().encrypt(JSON.stringify(b)))
    await axios.request({
      method: "POST",
      url: url,
      data: data,
      headers: {
        Authorization: encrypt_jwt_token,
        AppMode: 'core',
      },
      responseType: "json",
      onUploadProgress: (p) => {
        const progress = Math.round((p.loaded * 100) / p.total);
        setPercentage(progress)
      },
    }).then(x => {
      result = x.data
    })
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const CreateDataMultipleFiles = async (b, files, url, setPercentage) => {
  let result = { code: 'C-00', status: false, message: '' };
  try {
    b.created_by = await getCurrentUser();
    const data = new FormData();
    files.map(x => {
      data.append("files", x)
    })
    data.append("data", await crypter_c().encrypt(JSON.stringify(b)))
    await axios.request({
      method: "POST",
      url: url,
      data: data,
      headers: {
        Authorization: encrypt_jwt_token,
        AppMode: 'core',
      },
      responseType: "json",
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setPercentage(percentCompleted)
        // Update your UI (e.g., a progress bar) with the percentCompleted value
        // console.log(`Upload Progress: ${percentCompleted}%`);
      },
      // onUploadProgress: (p) => {
      //   console.log((p.loaded / p.total) * 100)
      //   setPercentage((p.loaded / p.total) * 100)
      // }
    }).then(x => {
      result = x.data
    })
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const UpdateDataMultipleFiles = async (b, files, url, setPercentage) => {
  let result = { code: 'U-00', status: false, message: '' };
  try {
    b.update_by = await getCurrentUser()
    const data = new FormData();
    files.map(x => {
      data.append("files", x)
    })
    data.append("data", await crypter_c().encrypt(JSON.stringify(b)))

    await axios.request({
      method: "PATCH",
      url: url,
      data: data,
      headers: {
        Authorization: encrypt_jwt_token,
        AppMode: 'core',
      },
      responseType: "json",
      onUploadProgress: (p) => {
        setPercentage((p.loaded / p.total) * 100)
      }
    }).then(x => {
      result = x.data
    })
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const getCurrentUser = async () => {
  let result = null
  const token_ls = JSON.parse(localStorage.getItem("authUser"));
  if (IsNotNull(token_ls)) {
    let tkn = token_ls.token
    if (IsNotNull(tkn)) {
      let decrypted = await crypter_s().decrypt(tkn)
      let rs_d = jwt.decode(decrypted);
      if (IsNotNull(rs_d)) {
        if (rs_d.exp * 1000 < Date.now()) {
          localStorage.clear();
          window.location.href = `${process.env.REACT_APP_DOMAIN}`
        } else {
          result = rs_d.user
        }
      }
    } else {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_DOMAIN}`
    }
  }
  return result
}

const getEmpIDCurrentUser = async () => {
  let result = null
  const token_ls = JSON.parse(localStorage.getItem("authUser"));
  if (IsNotNull(token_ls)) {
    let tkn = token_ls.token
    if (IsNotNull(tkn)) {
      let decrypted = await crypter_s().decrypt(tkn)
      let rs_d = jwt.decode(decrypted);
      if (IsNotNull(rs_d)) {
        if (rs_d.exp * 1000 < Date.now()) {
          localStorage.clear();
          window.location.href = `${process.env.REACT_APP_DOMAIN}`
        } else {
          result = { id: rs_d.employee, name: rs_d.e_name }
        }
      }
    } else {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_DOMAIN}`
    }
  }
  return result
}

const Get1File = async (b, url) => {
  let result = { data: null };
  try {
    await checkAuth()
    let enc = await crypter_c().encrypt(JSON.stringify(b))
    // let url = process.env.REACT_APP_API_URL + "stock-doc-get-file"
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.blob())
      .then(async x => {
        let buffer = await x.arrayBuffer();
        result.data = Buffer.from(buffer, 'base64')
        // let buffer = await x.arrayBuffer();
        // result = Buffer.from(buffer, 'base64')
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }

}

const GetBlob = async (b, url) => {
  let result = null;
  try {
    await checkAuth()
    let enc = await crypter_c().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.blob())
      .then(async x => {
        result = x
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

const DeleteS3Object = async (b, url) => {
  let result = { code: 'D-00', status: false, message: '' }
  try {
    b.update_by = await getCurrentUser()
    await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        data: await crypter_c().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result
  }
}


/**
  /**
  @param {this} troot this.
  @param {String} column column to sort.
  @param {Function} fncgetAll function to get Data.
  @param {Function} fncParams function Params.
  @param {String} stC string state column.
  @param {String} stSRT string state sort type.
*/
const sortColumn = (troot, column, fncgetAll, fncParams, stC, stSRT) => {
  let tmpSort = column !== troot.state[stC] ? true : !troot.state[stSRT]

  troot.setState({
    [stSRT]: tmpSort,
    [stC]: column
  })
  let b = fncParams()
  b.p4.column = column
  b.p4.sort_type = tmpSort ? "ASC" : "DESC"
  fncgetAll(b)
}

const getBadgeStatusValue = (x, styles) => {
  let data_status = [
    { id: 0, value: 'UNPROCESSED', style: 'badge-grey' },
    { id: 1, value: 'APPROVAL PROCESS', style: 'badge-orange' },
    { id: 2, value: 'APPROVED', style: 'badge-green' },
    { id: 3, value: 'APPROVED WITH EDIT', style: 'badge-green' },
    { id: 4, value: 'REJECTED', style: 'badge-red' },
    { id: 5, value: 'STORE PROCESS', style: 'badge-blue' },
    { id: 6, value: 'PACKING PROCESS', style: 'badge-blue' },
    { id: 7, value: 'DELIVERY PROCESS', style: 'badge-orange' },
    { id: 8, value: 'PURCHASE PROCESS', style: 'badge-blue' },
    { id: 9, value: 'PURCHASE IN SHIPPING', style: 'badge-orange' },
    { id: 10, value: 'DONE', style: 'badge-green' },
    { id: 11, value: 'DONE WITH REMARKS', style: 'badge-green' },
    { id: 12, value: 'PARTIAL RECEIVED', style: 'badge-red' },
    { id: 13, value: 'FULL RECEIVED', style: 'badge-green' },
  ]
  let rs = []
  if (IsNotNull(x)) {
    x.map((y, i) => {
      let f = data_status.find(l => l.id === y)
      if (IsNotNull(f)) {
        rs.push(
          <Tippy content={f.value} placement="bottom" key={i}>
            <span className={`${styles['badge']} ${styles[f.style]}`} key={i}>{f.value}</span>
          </Tippy>
        )
      }

    })
  }
  return rs
}

const getBadgePriority = (x, styles) => {
  let data_status = [
    { id: 1, value: 'AOG', style: 'badge-red' },
    { id: 2, value: 'URGENT', style: 'badge-orange' },
    { id: 3, value: 'NORMAL', style: 'badge-grey' }
  ]
  let rs = null
  if (IsNotNull(x)) {
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = <Tippy content={f.value} placement="bottom" >
        <span className={`${styles['badge']} ${styles[f.style]}`} >{f.value}</span>
      </Tippy>

    }
  }
  return rs
}

const getBadgeLeaveRequestStatus = (x, styles, scale) => {
  let data_status = [
    { id: 1, value: 'BELUM DIPROSES', style: 'badge-grey' },
    { id: 2, value: 'DISETUJUI', style: 'badge-green' },
    { id: 3, value: 'DITOLAK', style: 'badge-red' }
  ]
  let rs = null
  if (IsNotNull(x)) {
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = <Tippy content={f.value} placement="bottom" >
        <span className={`${styles['badge']} ${styles[f.style]} ${scale ? styles["total-days-scale"] : ''}`} >{f.value}</span>
      </Tippy>

    }
  }
  return rs
}

const getBadgeLeaveRequestStatusEN = (x, styles, scale) => {
  let data_status = [
    { id: 1, value: 'UNPROCESSED', style: 'badge-grey' },
    { id: 2, value: 'APPROVED', style: 'badge-green' },
    { id: 3, value: 'REJECTED', style: 'badge-red' }
  ]
  let rs = null
  if (IsNotNull(x)) {
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = <Tippy content={f.value} placement="bottom" >
        <span className={`${styles['badge']} ${styles[f.style]} ${scale ? styles["total-days-scale"] : ''}`} >{f.value}</span>
      </Tippy>

    }
  }
  return rs
}

const getLeaveRequestTypeValue = (x) => {
  let rs = ''
  if (IsNotNull(x)) {
    let data_status = [
      { id: 1, value: "Annual Leave" },
      { id: 2, value: "Sick-Self Leave" },
      { id: 3, value: "Sick-Family Leave" },
      { id: 4, value: "Maternity/Paternity Leave" },
      { id: 5, value: "Marriage Leave" },
      { id: 6, value: "Bereavement Leave" },
      { id: 7, value: "Religious Leave" },
      { id: 8, value: "Emergency Leave" },
      { id: 9, value: "Vacation Leave" },
      { id: 10, value: "Education Leave" },
      { id: 11, value: "Medical Appointment Leave" },
      { id: 12, value: "Administrative Leave" },
      { id: 13, value: "Other" },
    ]
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = f.value
    }
  }
  return rs;
}

const getPRPriorityValue = (x) => {
  let rs = ''
  if (IsNotNull(x)) {
    let data_status = [
      { id: 1, value: 'AOG' },
      { id: 2, value: 'URGENT' },
      { id: 3, value: 'NORMAL' },
    ]
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = f.value
    }
  }
  return rs;
}

const getPRUrgencyValue = (x) => {
  let rs = ''
  if (IsNotNull(x)) {
    let data_status = [
      { id: 1, value: 'URGENT' },
      { id: 2, value: 'NORMAL' },
    ]

    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = f.value
    }
  }
  return rs;
}

const getPRApproveValue = (x) => {
  let rs = ''
  if (x !== null && x !== undefined) {
    let data_status = [
      { id: 0, value: '-' },
      { id: 1, value: 'REJECTED' },
      { id: 2, value: 'APPROVED' },
      { id: 3, value: 'APPROVED WITH EDIT' },
    ]

    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = f.value
    }
  }
  return rs;
}

const getBadgeDeliveryStatus = (x, styles) => {
  let data_status = [
    { id: 0, value: 'UNPROCESSED', style: 'badge-grey' },
    { id: 1, value: 'ON_PREPARE_PROCESS', style: 'badge-blue' },
    { id: 2, value: 'ON_PACKING_PROCESS', style: 'badge-blue' },
    { id: 3, value: 'ON_DELIVERY_PROCESS', style: 'badge-blue' },
    { id: 4, value: 'ON_RECEIVE_CHECKING', style: 'badge-blue' },
    { id: 5, value: 'PARTIAL_RECEIVED', style: 'badge-red' },
    { id: 6, value: 'FULL_RECEIVED', style: 'badge-green' },
    { id: 7, value: 'DONE', style: 'badge-green' },
    { id: 8, value: 'DONE_WITH_REMARKS', style: 'badge-orange' },
  ]
  let rs = []
  if (IsNotNull(x)) {
    x.map((y, i) => {
      let f = data_status.find(l => l.id === y)
      if (IsNotNull(f)) {
        rs.push(
          <Tippy content={f.value} placement="bottom" key={i}>
            <span className={`${styles['badge']} ${styles[f.style]}`} key={i}>{f.value}</span>
          </Tippy>
        )
      }

    })
  }
  return rs
  // if (IsNotNull(x)) {
  //   let f = data_status.find(l => l.id === x)
  //   if (IsNotNull(f)) {
  //     rs = <Tippy content={f.value} placement="bottom" >
  //       <span className={`${styles['badge']} ${styles[f.style]}`} >{f.value}</span>
  //     </Tippy>

  //   }
  // }
  // return rs
}

const capitalizeFirstLetter = (x) => {
  if (IsNotNull(x)) {
    return x.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }

}



const getObjS3URL = async (b, url) => {
  let result = null;
  try {
    await checkAuth()
    let enc = await crypter_c().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypt_jwt_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'core',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.data)
          const decrypted = await crypter_s().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null;
  } finally {
    return result;
  }
}


export {
  IsNotNull,
  patternCheck,
  checkValue,
  getFormattedPrice,
  getFormattedNumber,
  MappingOptions,
  changeID,
  FindSetOption,
  toFloat,
  INNRD,
  str2ab,
  INNSD,
  toTitleCase,
  FindOption,
  MappingWNullOptions,
  condCheckRD,
  checkTotalQty,
  FindSetOptionWKey,
  ImageCompress,
  BlobsEqualCheck,
  getAllData,
  checkCreateResult,
  checkUpdateResult,
  dynamicSort,
  INNDRD,
  saveFile,
  openFileNewTab,
  DeleteData,
  DeleteDataWBody,
  GetOptData,
  UpdateData,
  GetAllData,
  CreateData,
  GetOptData1P,
  GetData,
  getCurrentUser,
  CreateDataMultipleFiles,
  UpdateDataMultipleFiles,
  Get1File,
  getEmpIDCurrentUser,
  sortColumn,
  getBadgeStatusValue,
  getPRPriorityValue,
  getPRUrgencyValue,
  getPRApproveValue,
  getBadgePriority,
  MappingWNullOptionsFComp,
  checkCreateResult2,
  checkDeleteResult,
  checkUpdateResult2,
  checkDeleteResult2,
  FindSetOption2,
  IsEmptyArray,
  notifBeforeAct,
  capitalizeFirstLetter,
  GetOptWBody,
  toNonFloat,
  getBadgeDeliveryStatus,
  getLeaveRequestTypeValue,
  getBadgeLeaveRequestStatus,
  checkApproveResult,
  checkFingerspotCommand,
  getObjS3URL,
  GetBlob,
  openURLNewTab,
  getBadgeLeaveRequestStatusEN,
  GetDataWOBody,
  CreateDataSingleFile,
  checkArraySimilarity,
  FormatTime,
  saveFileFromURL,
  DeleteS3Object
}